import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Ticket, User } from '../../_shared/models';
import { LoadingService, AuthenticationService } from '../../_shared/services';
import { Granule } from '../../config';

@Component({
  selector: 'app-ticket-item',
  templateUrl: './ticket-item.component.html',
  styleUrls: [
    './ticket-item.component.css',
    '../../../assets/css/core-navbar.css',
    '../_css-ticket/ticket-content.css'
  ]
})
export class TicketItemComponent implements OnInit, OnChanges {
  @Input() private ticket: Ticket;
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;
  private user: User;

  constructor(
    private granule: Granule,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.user = this.authenticationService.getUserInfo();
  }

  ngOnChanges() {}
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/ticket-item/ticket-item.component.ts